import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7dab6d70")

_pushScopeId("data-v-7dab6d70")
const _hoisted_1 = { class: "blue" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = { class: "cards-wrap" }
const _hoisted_4 = { class: "card third-card" }
const _hoisted_5 = { class: "card second-card" }
const _hoisted_6 = { class: "card first-card" }
const _hoisted_7 = { class: "red" }
const _hoisted_8 = { class: "label" }
const _hoisted_9 = {
  key: 0,
  class: "cards-wrap"
}
const _hoisted_10 = { class: "card second-card" }
const _hoisted_11 = { class: "card third-card" }
const _hoisted_12 = { class: "card first-card" }
const _hoisted_13 = {
  key: 1,
  class: "cards-wrap"
}
const _hoisted_14 = { class: "card first-card" }
const _hoisted_15 = { class: "card second-card" }
const _hoisted_16 = { class: "card third-card" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["d-card-result-view-root", { 'is-dragon-tiger': _ctx.gameType !== 'G002' }]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", {
        class: ["set-of-cards-wrap", { flashing: _ctx.winner === 6 || _ctx.winner === 3 }]
      }, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.blueTotal), 1),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (_ctx.blueHand.length > 2)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue3rdCard,
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_5, [
            (_ctx.blueHand.length > 1)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue2ndCard,
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_6, [
            (_ctx.blueHand.length > 0)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _ctx.blue1stCard,
                  onerror: "this.style.opacity='0'"
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", {
        class: ["set-of-cards-wrap", { flashing: _ctx.winner === 4 || _ctx.winner === 1 }]
      }, [
        _createVNode("div", _hoisted_8, _toDisplayString(_ctx.redTotal), 1),
        (_ctx.isLandscape)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                (
                                _ctx.gameType === 'G002'
                                    ? _ctx.redHand.length > 0
                                    : _ctx.redHand.length > 1
                            )
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.gameType === 'G002' ? _ctx.red1stCard : _ctx.red2ndCard,
                      onerror: "this.style.opacity='0'"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_11, [
                (
                                _ctx.gameType === 'G002'
                                    ? _ctx.redHand.length > 1
                                    : _ctx.redHand.length > 2
                            )
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.gameType === 'G002' ? _ctx.red2ndCard : _ctx.red3rdCard,
                      onerror: "this.style.opacity='0'"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_12, [
                (
                                _ctx.gameType === 'G002'
                                    ? _ctx.redHand.length > 2
                                    : _ctx.redHand.length > 0
                            )
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.gameType === 'G002' ? _ctx.red3rdCard : _ctx.red1stCard,
                      onerror: "this.style.opacity='0'"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_13, [
              _createVNode("div", _hoisted_14, [
                (
                                _ctx.gameType === 'G002'
                                    ? _ctx.redHand.length > 2
                                    : _ctx.redHand.length > 0
                            )
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.gameType === 'G002' ? _ctx.red3rdCard : _ctx.red1stCard,
                      onerror: "this.style.opacity='0'"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_15, [
                (
                                _ctx.gameType === 'G002'
                                    ? _ctx.redHand.length > 0
                                    : _ctx.redHand.length > 1
                            )
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.gameType === 'G002' ? _ctx.red1stCard : _ctx.red2ndCard,
                      onerror: "this.style.opacity='0'"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_16, [
                (
                                _ctx.gameType === 'G002'
                                    ? _ctx.redHand.length > 1
                                    : _ctx.redHand.length > 2
                            )
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: _ctx.gameType === 'G002' ? _ctx.red2ndCard : _ctx.red3rdCard,
                      onerror: "this.style.opacity='0'"
                    }, null, 8, ["src"]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ], 2)
    ]),
    _createVNode("div", {
      class: ["winner-label", _ctx.winnerColor]
    }, _toDisplayString(_ctx.winnerLabel), 3)
  ], 2))
})